import { z } from 'zod';

export const PARTNER_ORGANIZATION_SCHEMA = z.union([z.number(), z.literal('TRANSPORT_EXCHANGE')]);

export type PARTNER_ORGANIZATION = z.infer<typeof PARTNER_ORGANIZATION_SCHEMA>;
